import React, { Component } from 'react'
import Logo from "../assets/logos/s-logo.svg";

export default class NotFound extends Component {
    render() {
        return (
        <div className="not-found">
            <div className="su-logo-box">
                <img src={Logo} alt="logo" />
            </div>
        
            <div className="nf-box" >
                <div className="not-found-content ">
                    <h1>404  </h1>
                    <h2> Not Found</h2>
                    <p> This url doesn't exist</p>
                </div>
            </div>
       </div>
        )
    }
}
